<template>
  <div>
    <div class="fullscreen-modal__content">
      <page>
        <page-title>
          {{ $t('c.mailingOverlay.stepRecipients.title') }}
        </page-title>

        <div class="mailing__topbar">
          <div class="mailing__topbar--left" />
          <div class="mailing__topbar--right">
            <dropdown-input
              :options="selectDropdownOptions"
              theme="primary"
              position="right"
              @select="handleSelectDropdownSelect"
            >
              <button-input>
                <font-awesome-icon icon="toggle-on" />
                <font-awesome-icon icon="angle-down" />
              </button-input>
            </dropdown-input>
          </div>
        </div>

        <list-item
          v-for="recipient in recipients"
          :key="recipient.email"
          :title="recipient.email"
          :subline="recipient.interests | tags"
          :avatar-name="recipient.email"
          :switch-value="isSelected(recipient)"
          @switch-input="select(recipient)"
        />
      </page>
    </div>
    <div class="fullscreen-modal__footer">
      <div class="container">
        <div class="row">
          <div class="col-xs-6 col-lg-4 push-lg-2">
            <button-input
              v-t="'c.mailingOverlay.stepRecipients.btnNext'"
              :is-disabled="stepIsInvalid"
              @click="nextStep"
            />
          </div>

          <div class="col-xs-6 col-lg-4 push-lg-2 text-right">
            <button-input
              v-t="'c.mailingOverlay.stepRecipients.btnBack'"
              color="grey"
              @click="prevStep"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import FormMixin from '@/mixins/forms/Form'
import PageMixin from '@/mixins/pages/Page'
import tags from '@/filters/tags'
import ListItem from '@/components/ui/ListItem'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  mixins: [FormMixin, PageMixin],
  filters: {
    tags
  },
  components: {
    ListItem,
    FontAwesomeIcon
  },
  computed: {
    ...mapState ({
      recipients: state => state.mailing.entry.recipients,
      selected: state => state.mailing.entry.recipients.filter(recipient => recipient.selected),
      folder: state => state.folder.folder
    }),
    ...mapGetters ({
      isSelected: 'mailing/entry/isRecipientSelected',
    }),
    selectDropdownOptions () {
      return [
        { label: 'Alle auswählen', value: 'selectall', icon: 'toggle-on' },
        { label: 'Alle abwählen', value: 'deselectall', icon: 'toggle-off' }
      ]
    },
    stepIsInvalid () {
      return this.selected.length === 0
    }
  },
  methods: {
    ...mapActions ({
      select: 'mailing/entry/selectRecipient',
      selectAllRecipients: 'mailing/entry/selectAllRecipients',
      prevStep: 'mailing/step/prev',
      nextStep: 'mailing/step/next',
    }),
    handleSelectDropdownSelect ({ value }) {
      switch (value) {
        case 'selectall':
          this.selectAllRecipients(true)
          break
        case 'deselectall':
          this.selectAllRecipients(false)
          break
        default:
          window.alert(`action: ${value}`)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mailings/steps/Recipients.vue